<template>
    <div class="car-video-detail">
        <div class="left">
            <div class="video-play-wrapper">
                <div class="v-player" @dblclick="handleVideoDbclk">
                    <video-player
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="options"
                        class="video-player vjs-custom-skin"
                        @ready="onPlayerReadied"
                        @ended="onPlayerEnd"
                    ></video-player>
                </div>
                <div class="car-video-title">
                    {{videoData.title}}
                </div>
                <div class="car-video-author">
                    <div class="car-video-author-avatar">
                        <img src="@/assets/images/bitmap-small.png" v-real-src="videoData.mthpic" alt="">
                    </div>
                    <div class="car-video-author-description">
                        <div class="car-video-author-name">{{videoData.source_name}}</div>
                        <div class="car-video-author-info">
                            <span class="info-item">发布时间：{{videoData.publish_time | filterVideoTime}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div v-if="relateSeires && relateSeires.length" class="r-card related-car-card">
                <div class="title">相关车</div>
                <div 
                    v-for="(car, index) in relateSeires"
                    :key="index"
                    class="r-card-item"
                    @click="goCarTrain(car.series_id, car.name)"
                >
                    <div class="car-pic">
                        <img src="@/assets/images/bitmap-small.png" v-real-src="car.white_bg_img" alt="">
                    </div>
                    <div class="car-content">
                        <div class="car-name">
                            <span class="car-serise-name">{{car.name}}</span>
                            <span class="car-brand-name">{{car.brand_name}}</span>
                        </div>
                        <div class="prise">{{car.price}}</div>
                        <div
                            class="ask-prise-btn"
                            :data-key="'series_' + car.series_id"
                            :data-seriesId="car.series_id"
                            :data-seriesName="car.name"
                            :data-pos="index"
                            @click.stop.prevent="askPrice(car, index)"
                        >获取底价</div>
                    </div>
                </div>
            </div>
            <div v-if="recVideoList && recVideoList.length" class="r-card next-video-card">
                <div class="title">接下来播放</div>
                <div 
                    v-for="(rec, index) in recVideoList"
                    :key="index"
                    class="r-card-item"
                    @click="goVideo(rec, index)"
                >
                    <div class="car-pic">
                        <img src="@/assets/images/bitmap-small.png" v-real-src="rec.thumbnail[0].pic_url" alt="">
                        <p class="feeds-link-video">
                            <i class="c-icon c-icon-rec-play">&#xe631;</i>
                            <span>{{rec.duration_display}}</span>
                        </p>
                    </div>
                    <div class="car-content">
                        {{rec.title}}
                    </div>
                </div>
            </div>
        </div>
        <c-qrcode position="SINGLE"/>
    </div>
</template>

<script>

/**
* @file videoDetail
* @author v_xiongdingfeng
*/
import request from 'http/request';
import {videoPlayer} from 'vue-video-player';
import 'video.js/dist/video-js.css';
import URLS from 'http/URLS';
import mixinLog from '@/mixin/log.js';
import {sendLog, inSightObserver, inSightObserverDisconnect} from 'js/log';
import {mapState} from 'vuex';
import {
    openUrlInNewTab,
    handleErr
} from '@/common/js/core';
import Qrcode from '@/components/qrcode';

export default {
    name: 'videoDetail',
    mixins: [mixinLog],
    components: {
        videoPlayer,
        'c-qrcode': Qrcode
    },
    props: {
        nid: String
    },
    data() {
        return {
            options: {
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                autoplay: true,
                muted: false,
                loop: false,
                preload: 'auto',
                language: 'zh-CN',
                aspectRatio: '16:9',
                fluid: true,

                /* eslint-disable-next-line */
                poster: 'data:image/png;base64,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',
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true
                }
            },
            videoData: {},
            relateSeires: [],
            serid: '',
            seriesName: '',
            recVideoList: [],
            player: null
        };
    },
    created() {
        this.initData();
        this.getData();
        this.getRecVideo();
    },
    beforeDestroy() {
        inSightObserverDisconnect();
    },
    filters: {
        filterVideoTime(value) {
            if (!value) {
                return '00-00 00:00';
            }
            const date = new Date(value);
            if (date instanceof Date) {
                const p = function (s) {
                    return s < 10 ? '0' + s : s;
                };
                return p(date.getMonth() + 1) + '-'
                    + p(date.getDate()) + ' '
                    + p(date.getHours()) + ':'
                    + p(date.getMinutes());
            }

            return '00-00 00:00';
        }
    },
    computed: {
        ...mapState(['location', 'uid'])
    },
    methods: {
        initData() {
            let {
                serid,
                sername
            } = this.$route.query;
            this.serid = serid;
            this.seriesName = sername;

            // 兼容低版本路由
            if (this.$route.query.nid && !this.nid) {
                this.nid = this.$route.query.nid;
            }
        },
        async getData() {
            let res = {};
            try {
                res = await request(URLS.GETVIDEO, {
                    nid: this.nid
                },
                    {
                        method: 'GET'
                    });
            }
            catch (error) {
                return handleErr(error);
            }
            if (!res.Result) {
                return;
            }

            this.videoData = res.Result.news;
            this.relateSeires = res.Result.relate_seires;
            this.player.src(this.videoData.play_url);
            this.player.poster(this.videoData.poster);

            this.$nextTick(() => {
                inSightObserver(
                    '.ask-prise-btn',
                    'video_detail_askprice_show',
                    null,
                    ['seriesName', 'seriesId', 'pos']
                );
            });
        },
        getRecVideo() {
            /* eslint-disable fecs-camelcase */
            const baseParams = {
                appname: 'youjia',
                network: '1_0', // 对应都是wifi
                bdvc: 0,
                ua: navigator.userAgent.replace(/\s/g, ''),
                uid: this.uid,
                // ut取不到，所以写死一个
                // time: +new Date(),
                ut: encodeURIComponent('iPhone 8 plus <iPhone10,2>') + '_' + encodeURIComponent('iOS 11.4'),
                series_name: this.seriesName || '',
                nid: this.nid
            };
            if (this.seriesName) {
                baseParams.time = +new Date();
            }
            const locationPos = this.location;

            let info = {
                location_type: '0'
            };

            if (locationPos.lat) {
                info.location = `${locationPos.lat},${locationPos.long},--460-00`;
            }

            const postData = {
                data: JSON.stringify({
                    tab_id: this.seriesName ? '14009' : '14006', // 视频落地页推荐
                    tab_name: '视频',
                    last_update_time: +new Date(),
                    refresh_state: '5',
                    refresh_index: 0, // 只有一个tab, 故refresh_index===refresh_count
                    refresh_count: 0,
                    guide_refresh: '0',
                    pull_to_refresh_count: '0'
                }),
                info: JSON.stringify(info)
            };

            /* eslint-enable fecs-camelcase */

            request(URLS.GETSERIESREC, baseParams, {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                method: 'post',
                data: postData
            }).then(res => {
                if (res.Result && res.Result.length) {
                    if (this.recVideoList.length) {
                        let tmp = this.recVideoList;
                        tmp.push(...res.Result);
                        this.$set(this.recVideoList, tmp);

                    }
                    else {
                        let tmp = [];
                        tmp.push(...res.Result);
                        this.recVideoList = res.Result;
                        this.$set(this.recVideoList, tmp);
                    }
                }

            }).catch(e => {
                handleErr(e);
            });
        },
        askPrice(item, pos) {
            openUrlInNewTab({
                name: 'ASK_PRICE',
                query: {
                    fromPage: `${this.$route.path}@video_detail_ask_price@${pos}`
                },
                params: {
                    serid: item.series_id
                }
            });
            /* eslint-disable fecs-camelcase */
            this.sendLog('ask_price', {
                id: item.series_id,
                pos,
                price_url: item.ask_price_url || ''
            });
            /* eslint-enable fecs-camelcase */
        },
        goCarTrain(serid, sername) {
            openUrlInNewTab(
                {
                    name: 'CAR_TRAIN',
                    query: {
                        seriesName: sername
                    },
                    params: {
                        serid
                    }
                }
            );
            this.sendLog('relate_series', {
                id: serid
            });
        },
        goVideo(video, pos) {
            this.$router.push(
                {
                    name: 'VIDEO_DETAIL',
                    params: {
                        nid: video.nid
                    },
                    query: this.$route.query
                }
            );
            this.sendLog('next_video', {
                relNid: video.nid,
                pos
            });
        },
        onPlayerEnd() {
            if (this.recVideoList.length > 0) {
                // this.nid = this.recVideoList[0].nid;
                // this.getData().then(() => {
                //     let tmp = this.recVideoList;
                //     tmp.shift(0);
                //     this.$set(this.recVideoList, tmp);

                // });
                this.$router.push({
                    params: {
                        nid: this.recVideoList[0].nid
                    },
                    query: this.$route.query
                });
            }
            // if (this.recVideoList.length < 3) {
            //     this.getRecVideo();
            // }
        },
        onPlayerReadied(e) {
            this.player = e;
            this.player.src(this.videoData.play_url);
            this.player.poster(this.videoData.poster);
        },
        handleVideoDbclk() {
            if (!!(document.fullscreen
                || document.mozFullScreen
                || document.webkitIsFullScreen
                || document.webkitFullScreen
                || document.msFullScreen)) {
                if (this.player.el_.exitFullscreen) {
                    this.player.el_.exitFullscreen();
                }
                else if (this.player.el_.mozCancelFullScreen) {
                    this.player.el_.mozCancelFullScreen();
                }
                else if (this.player.el_.webkitExitFullscreen) {
                    this.player.el_.webkitExitFullscreen();
                }
                else if (this.player.el_.msExitFullscreen) {
                    this.player.el_.msExitFullscreen();
                }
                else if (this.player.exitFullscreen) {
                    this.player.exitFullscreen();
                }
            }
            else {
                if (this.player.el_.requestFullscreen) {
                    this.player.el_.requestFullscreen();
                }
                else if (this.player.el_.mozRequestFullScreen) {
                    this.player.el_.mozRequestFullScreen();
                }
                else if (this.player.el_.webkitRequestFullscreen) {
                    this.player.el_.webkitRequestFullscreen();
                }
                else if (this.player.el_.msRequestFullscreen) {
                    this.player.el_.msRequestFullscreen();
                }
            }
        },
        sendLog(key, data) {
            sendLog(`video_detail_${key}`, Object.assign({}, {
                seriesId: this.seriesId,
                seriesName: this.seriesName,
                nid: this.nid
            }, data));
        }
    }
};
</script>

<style scoped lang="less">
@themeColor: #00CECF;

.car-video-detail {
    display: flex;
    overflow: hidden;
    width: 100%;
    margin-top: 30px;
    font-family: PingFang-SC-Medium;

    justify-content: space-between;
}
.left {
    width: 750px;
}
.right {
    width: 399px;
}
.video-play-wrapper {
    margin-bottom: 24px;
    .v-player {
        position: relative;
        width: 750px;
        height: 423px;
        /deep/ .video-js {
            width: 750px;
            height: 423px;
            font-size: 10px;
            background-color: transparent;
            .vjs-poster {
                outline: none!important;
                background-color: transparent;
            }
            video,
            button,
            .vjs-menu-item {
                outline: none!important;
            }
            .vjs-big-play-button {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 80px;
                height: 80px;
                border: none;
                line-height: 80px;
                text-align: center;
                border-radius: 80px;
                background-color: rgba(0, 0, 0, .4);
                background-image: url("~assets/images/play.svg");
                background-repeat: no-repeat;
                background-position: center;
                background-size: 50px;
                transform: translate(-50%, -50%);
                &:hover {
                    background-color: rgba(0, 0, 0, .6);
                }
            }
            .vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button {
                position: relative;
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background-color: transparent;
                }
            }
        }
    }
    .car-video-title {
        display: -webkit-box;
        overflow: hidden;
        width: 100%;
        margin-top: 24px;
        margin-bottom: 25px;
        padding: 0 2px;
        font-size: 32px;
        line-height: 1.4;
        text-overflow: ellipsis;
        color: #333;

        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .car-video-author {
        position: relative;
        display: flex;
        width: 100%;
        height: 42px;
        .car-video-author-avatar {
            display: inline-block;
            overflow: hidden;
            width: 42px;
            min-width: 42px;
            max-width: 42px;
            height: 42px;
            margin-right: 9px;
            border-radius: 50%;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .car-video-author-avatar-icon {
            position: absolute;
            bottom: 0;
            left: 28px;
            overflow: hidden;
            width: 15px;
            height: 15px;
            border: 2px solid #fff;
            border-radius: 50%;
        }
        .car-video-author-description {
            width: 100%;
            height: 42px;
            .car-video-author-name {
                height: 21px;
                font-size: 14px;
                color: #333;
            }
            .car-video-author-info {
                height: 21px;
                font-family: PingFang-SC-Regular;
                font-size: 12px;
                line-height: 21px;
                color: #999;
                .line {
                    display: inline-block;
                    width: 1px;
                    height: 12px;
                    margin: 0 12px;
                    vertical-align: middle;
                    border-radius: .5px;
                    background: #d8d8d8;
                }
                .info-item {
                    display: inline-block;
                }
            }
        }
    }
}
.right .r-card {
    width: 100%;
    .title {
        height: 28px;
        margin: 24px 0;
        font-size: 20px;
        color: #333;
    }
    .r-card-item {
        display: flex;
        overflow: hidden;
        width: 100%;
        height: 100px;
        margin-bottom: 24px;

        align-items: center;
        .car-pic {
            position: relative;
            width: 150px;
            min-width: 150px;
            height: 100px;
            margin-right: 12px;
            cursor: pointer;

            flex-basis: 150px;
            flex-shrink: 0;
            object-fit: cover;
            .feeds-link-video {
                position: absolute;
                right: 5px;
                bottom: 5px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                padding: 6px 7px;
                font-size: 12px;
                line-height: 12px;
                color: #fff;
                border-radius: 30px;
                background: rgba(0, 0, 0, .4);

                align-items: center;
                -webkit-box-align: center;
                -webkit-box-pack: center;
                -ms-flex-align: center;
                -ms-flex-pack: center;
                justify-content: center;
            }
            img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
}
.related-car-card {
    border-bottom: 1px solid #eee;
    .car-content {
        text-align: left;
    }
    .car-serise-name {
        margin-right: 12px;
        font-size: 16px;
        line-height: 16px;
        color: #333;
    }
    .car-brand-name {
        font-family: PingFang-SC-Regular;
        font-size: 14px;
        line-height: 14px;
        color: #999;
    }
    .car-name {
        margin-bottom: 8px;
    }
    .prise {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 16px;
        color: #ff6f61;
    }
    .ask-prise-btn {
        display: inline-block;
        width: 74px;
        height: 28px;
        border: 1px solid @themeColor;
        font-family: PingFang-SC-Regular;
        font-size: 14px;
        line-height: 28px;
        text-align: center;
        color: @themeColor;
        border-radius: 3px;
        border-radius: 3px;
        cursor: pointer;
    }
}
.next-video-card {
    .car-content {
        display: -webkit-box;
        overflow: hidden;
        font-size: 16px;
        text-overflow: ellipsis;
        color: #333;

        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    &.r-card .r-card-item .car-pic {
        width: 160px;
        height: 90px;
    }
}
</style>